import { render } from "./OrganismsNavigation.vue?vue&type=template&id=74d5f627&scoped=true&ts=true"
import script from "./OrganismsNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsNavigation.vue?vue&type=style&index=0&id=74d5f627&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d5f627"],['__file',"src/components/organisms/OrganismsNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74d5f627"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74d5f627', __exports__)) {
    api.reload('74d5f627', __exports__)
  }
  
  module.hot.accept("./OrganismsNavigation.vue?vue&type=template&id=74d5f627&scoped=true&ts=true", () => {
    api.rerender('74d5f627', render)
  })

}


export default __exports__